module.exports = __webpack_public_path__ + "img/dsll10cd.f404d423.png";